module.exports = __webpack_public_path__ + "static/media/event-guarantee-1.e0a75264.jpg";